// extracted by mini-css-extract-plugin
export default {"table":"Table_table__RpkAH","buttons":"Table_buttons__QoWfg"};